export default {
	interval: null,
	order: [],
	divs: [],
	left: [],
	reset: false,
	rate: 1800,
	init() {
		if (!document.querySelector(".top-logos")) {
			return;
		}
		this.divs = Array.from(document.querySelectorAll(".top-logos"));
		this.repopulate();
		this.interval = setInterval(this.tick.bind(this), this.rate);
	},
	repopulate() {
		this.left = [...this.divs];
	},
	addTo(div) {
		if (!div.classList.contains("step-1")) {
			div.classList.remove("step-3");
			div.classList.add("step-1");
		} else if (!div.classList.contains("step-2")) {
			div.classList.add("step-2");
			div.addEventListener(
				"transitionend",
				() => {
					div.classList.add("step-3");
					div.classList.remove("step-1", "step-2");
				},
				{ once: true }
			);
		}
	},
	swap() {
		const index = Math.floor(Math.random() * this.left.length);
		const div = this.left[index];
		this.left = this.left.filter((node) => node != div);
		this.addTo(div);
	},
	tick() {
		if (!this.left.length) {
			this.repopulate();
		}
		this.swap();
	},
	destroy() {
		clearInterval(this.interval);
		this.interval = false;
	},
};
